import { isMarginType } from "./servicesValidation";

/**
 * Configuración por defecto para la pantalla configsRec.
 * Reproduce el comportamiento actual de tabs y tablas.
 */
export const DEFAULT_CONFIGS_REC = {
  tabs: {
    margin: {
      show: true,
      label: "Márgenes",
      label_markup: "Markups",
    },
    competitor: {
      show: true,
      label: "Competidor",
    },
    stock: {
      show: true,
      label: "Stock",
    },
    replacement_cost: {
      show: true,
      label: "Costo",
    },
    promotions: {
      show: true,
      label: "Promociones",
    },
    objective: {
      show: true,
      label: "Objetivo",
    },
    visibility: {
      show: true,
      label: "Visibilidad",
    },
  },
  tables: {
    margin: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        cost_price: { show: true, label: "COSTO", field: "cost_price", format: "currency" },
        unit_price: { show: true, label: "PRECIO LISTA", field: "unit_price", format: "currency" },
        unit_sale: { show: true, label: "PRECIO VENTA", field: "unit_sale", format: "currency" },
        margin_percent_list: {
          show: true,
          label: "MARGEN LISTA",
          label_markup: "MARKUP LISTA",
          field: "margin_percent_list",
          format: "percent",
        },
        margin_percent: {
          show: true,
          label: "MARGEN VENTA",
          label_markup: "MARKUP VENTA",
          field: "margin_percent",
          format: "percent",
        },
        food_cost: {
          show: false,
          label: "FOOD COST",
          field: "food_cost",
          format: "percent",
          conditional: "client_34",
        },
        margin_min: { show: true, label: "MÍN", field: "margin_min", format: "percent" },
        margin_objective: { show: true, label: "OBJETIVO", field: "margin_objective", format: "percent" },
        margin_max: { show: true, label: "MÁX", field: "margin_max", format: "percent" },
        margin_config_status: { show: true, label: "ESTADO CONF.", field: "margin_config_status", format: "badge" },
        margin_config_updated_at: { show: true, label: "ÚLTIMA ACT.", field: "margin_config_updated_at", format: "date" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    competitor: {
      columns: {
        product_sku: { show: true, label: "SKU", field: "product_sku" },
        product_name: { show: true, label: "PRODUCTO", field: "product_name" },
        product_unit_sale: { show: true, label: "PRECIO ACTUAL", field: "product_unit_sale", format: "currency" },
        value: { show: true, label: "DIFERENCIA %", field: "value", format: "percent" },
        rule: { show: true, label: "POSICIONAMIENTO", field: "rule", format: "positioning" },
        codex_product_competitor: { show: true, label: "COMPETIDOR SKU/URL", field: "codex_product_competitor" },
        competitor_name: { show: true, label: "COMPETIDOR REF.", field: "competitor_name" },
        competitor_status: { show: true, label: "ESTADO", field: "competitor_status", format: "badge" },
        date_last_manual_update: { show: true, label: "FECHA DE REGISTRO DE SKU/URL", field: "date_last_manual_update", format: "date" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    stock: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        coverage_days_min: { show: true, label: "DIAS DE COBERTURA MIN", field: "coverage_days_min" },
        coverage_days: { show: true, label: "DIAS DE COBERTURA", field: "coverage_days" },
        coverage_days_max: { show: true, label: "DIAS DE COBERTURA MAX", field: "coverage_days_max" },
        price_action: { show: true, label: "ACCION ACTIVA", field: "price_action", format: "badge" },
        stock_situation: { show: true, label: "SITUACION", field: "stock_situation", format: "badge" },
        inventory_alarm_type: { show: true, label: "ESTADO", field: "inventory_alarm_type", format: "badge" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    replacement_cost: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        cost_price: { show: true, label: "COSTO REPOSICIÓN", field: "cost_price", format: "currency" },
        cost_updated_at: { show: true, label: "FECHA ACT.", field: "cost_updated_at", format: "datetime" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    promotions: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        active_promotion: { show: true, label: "ESTADO DE PROMOCIÓN", field: "active_promotion", format: "boolean_badge" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    objective: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        goal: { show: true, label: "OBJETIVO DE OPTIMIZACIÓN", field: "goal", format: "goal_badge" },
        sensibility: { show: true, label: "ELASTICIDAD", field: "sensibility", format: "elasticity_html" },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
    visibility: {
      columns: {
        sku: { show: true, label: "SKU", field: "sku" },
        long_name: { show: true, label: "PRODUCTO", field: "long_name" },
        store_name: { show: true, label: "LISTA DE PRECIO", field: "store_name", conditional: "active_store" },
        visibility_number: {
          show: true,
          label: "VISIBILIDAD",
          field: "visibility_number",
          group: "visibility",
          colspan: 2,
        },
        visibility: {
          show: true,
          label: "",
          field: "visibility",
          group: "visibility",
          hidden_header: true,
        },
        actions: { show: true, label: "ACCIONES", type: "actions" },
      },
    },
  },
};

/**
 * Deep merge de objetos. No muta los originales.
 */
function deepMerge(target, source) {
  if (!source) return target;
  const output = { ...target };
  Object.keys(source).forEach((key) => {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      output[key] = deepMerge(output[key] || {}, source[key]);
    } else {
      output[key] = source[key];
    }
  });
  return output;
}

/**
 * Retorna la configuración completa mezclando el default con la del cliente.
 */
export function getConfigsRecConfig(authenticationUser) {
  const userConfig = authenticationUser?.client_configs_rec || {};
  return deepMerge(DEFAULT_CONFIGS_REC, userConfig);
}

/**
 * Determina si una columna debe mostrarse según condicionales del cliente.
 */
export function shouldShowColumn(columnConfig, authenticationUser) {
  if (!columnConfig || columnConfig.show === false) return false;

  const conditional = columnConfig.conditional;
  if (!conditional) return true;

  if (conditional === "active_store") {
    return !!authenticationUser?.active_store;
  }

  if (conditional === "client_34") {
    return authenticationUser?.client === 34;
  }

  return true;
}

/**
 * Resuelve el label de una columna considerando Margen/Markup.
 */
export function resolveColumnLabel(columnConfig, authenticationUser, activeServiceId = null) {
  if (!columnConfig) return "";

  const isMargin = isMarginType(authenticationUser, activeServiceId);
  const markupLabel = columnConfig.label_markup;

  if (!isMargin && markupLabel) {
    return markupLabel;
  }

  return columnConfig.label || "";
}

/**
 * Retorna la lista de tabs visibles ordenados.
 */
export function getVisibleTabs(config, authenticationUser, routeName) {
  if (!config?.tabs) return [];

  const tabOrder = [
    { key: "margin", component: "config-margin" },
    { key: "competitor", component: "config-competitor" },
    { key: "stock", component: "config-stock" },
    { key: "replacement_cost", component: "config-reposicion" },
    { key: "promotions", component: "config-promociones" },
    { key: "objective", component: "config-objective" },
    { key: "visibility", component: "config-visibility" },
  ];

  return tabOrder
    .map((tab) => ({
      ...tab,
      ...config.tabs[tab.key],
    }))
    .filter((tab) => {
      if (!tab.show) return false;
      // Reglas de negocio actuales
      if (tab.key === "objective" && routeName !== "op-configs") return false;
      if (tab.key === "visibility" && authenticationUser?.client !== 49) return false;
      return true;
    });
}

/**
 * Retorna la configuración de una tabla específica.
 */
export function getTableConfig(config, tableKey) {
  return config?.tables?.[tableKey] || { columns: {} };
}

/**
 * Retorna las columnas visibles de una tabla en el orden definido.
 */
export function getVisibleColumns(config, tableKey, authenticationUser) {
  const tableConfig = getTableConfig(config, tableKey);
  const columns = tableConfig.columns || {};

  return Object.keys(columns)
    .map((key) => ({ key, ...columns[key] }))
    .filter((column) => shouldShowColumn(column, authenticationUser));
}

/**
 * Resuelve el label de un tab considerando Margen/Markup.
 */
export function resolveTabLabel(tabConfig, authenticationUser, activeServiceId = null) {
  if (!tabConfig) return "";

  const isMargin = isMarginType(authenticationUser, activeServiceId);
  if (tabConfig.key === "margin" && !isMargin && tabConfig.label_markup) {
    return tabConfig.label_markup;
  }

  return tabConfig.label || "";
}

export default {
  DEFAULT_CONFIGS_REC,
  getConfigsRecConfig,
  shouldShowColumn,
  resolveColumnLabel,
  getVisibleTabs,
  getTableConfig,
  getVisibleColumns,
  resolveTabLabel,
};
